import LegalMarkdownPage from "./LegalMarkdownPage";

import childSafetyEnglish from "../docs/child-safety/child-safety.en.md";
import childSafetyFrench from "../docs/child-safety/child-safety.fr.md";
import childSafetyArabic from "../docs/child-safety/child-safety.ar.md";

import "../styles/LegalPages.css";

const childSafetyDocuments = {
  en: childSafetyEnglish,
  fr: childSafetyFrench,
  ar: childSafetyArabic,
  es: childSafetyEnglish, // no Spanish market yet, English reference version
  it: childSafetyEnglish, // no Italian market yet, English reference version
};

const ChildSafetyPage = () => {
  return (
    <LegalMarkdownPage
      documents={childSafetyDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Child Safety Standards could not be loaded."
    />
  );
};

export default ChildSafetyPage;
